import {
  AGENT_STEP_KEYS,
  CART_DELAYS,
  STEP_AGENT_TYPES,
  STORE_STEP_KEYS,
  storeSettings,
  UPSELL_LEADS
} from '@/config/agentWizardSteps'
import { blankAgentForm, buildAgentPayload } from '@/helpers/agentPayload'

const DELAY_OPTIONS = { carts: CART_DELAYS, upsell: UPSELL_LEADS }
const DELAY_FIELDS = { carts: 'delay', upsell: 'lead' }

const applyWinback = (form, { winback }) => {
  form.winback.lost.lost_window_days = winback.lost_window_days
  form.winback.lost.outreach_template = winback.lost_message
  form.winback.slipping.enabled = winback.slipping_enabled
  form.winback.slipping.outreach_template = winback.slipping_message
  ;[form.winback.lost, form.winback.slipping].forEach(segment => {
    segment.offer_enabled = winback.offer_enabled
    segment.discount_code_id = winback.discount_code_id
  })
  return ''
}

const applyReviews = (form, { reviews }) => {
  form.review.order_threshold = reviews.order_threshold
  form.review.google_review_link = reviews.google_review_link
  form.review.checkin_template = reviews.checkin_message
  return ''
}

const applyStoreStep = stepKey => (form, data, storeId) => {
  const settings = storeSettings(data, stepKey, storeId)
  const option = DELAY_OPTIONS[stepKey].find(candidate => candidate.key === settings[DELAY_FIELDS[stepKey]])
  form.belongs_to_id = storeId
  form.trigger_time_value = option.value
  form.trigger_time_type = option.type
  if (stepKey === 'carts') {
    form.offer_enabled = settings.offer_enabled
    form.discount_code_id = settings.discount_code_id
  }
  return settings.message
}

const APPLIERS = {
  winback: applyWinback,
  reviews: applyReviews,
  carts: applyStoreStep('carts'),
  upsell: applyStoreStep('upsell')
}

export const agentFormFor = (stepKey, data, storeId = '') => {
  const form = { ...blankAgentForm(), type: STEP_AGENT_TYPES[stepKey] }
  const outreachContent = APPLIERS[stepKey](form, data, storeId)
  return { form, outreachContent }
}

const entryFor = (stepKey, data, storeId) => {
  const { form, outreachContent } = agentFormFor(stepKey, data, storeId)
  return buildAgentPayload(form, { outreachContent })
}

const entriesForStep = (stepKey, data) => {
  if (!data[stepKey].enabled) return []
  if (!STORE_STEP_KEYS.includes(stepKey)) return [entryFor(stepKey, data)]
  return data[stepKey].store_ids.map(storeId => entryFor(stepKey, data, storeId))
}

const profileFor = ({ voice, about }) => ({
  agent_tone: voice.tone,
  agent_formality_level: voice.formality_level,
  agent_enthusiasm_level: voice.enthusiasm_level,
  agent_emoji_enabled: voice.emoji_enabled,
  agent_brand_voice_summary: voice.brand_voice_summary,
  agent_additional_context: about.additional_context
})

export const buildSetupPayload = data => ({
  agent_setup: {
    profile: profileFor(data),
    agents: AGENT_STEP_KEYS.flatMap(stepKey => entriesForStep(stepKey, data))
  }
})
